<form
  [formGroup]="addressForm"
  (keydown.enter)="enter($event)"
  [ngClass]="{ submitted: formSubmitted }"
  >
  <div>
    <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
      <div
        fxLayout="col"
        fxFlex="100"
        class="add-patient-col"
        fxLayoutAlign="start center"
        >
        {{ "Street" | translate }}
        <span class="optional">{{ "(optional)" | translate }}</span>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
      <div fxLayout="col" fxFlex="100" class="add-patient-col">
        <input
          class="add-patient-input"
          [placeholder]="'Street' | translate"
          formControlName="street"
          [maxLength]="51"
          />
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
        <div
          fxLayout="col"
          fxFlex="33"
          class="add-patient-col"
          fxLayoutAlign="start center"
          >
          {{ "Street Number" | translate }}
          <span class="optional">{{ "(optional)" | translate }}</span>
        </div>
        <div
          fxLayout="col"
          fxFlex="33"
          class="add-patient-col"
          fxLayoutAlign="start center"
          >
          {{ "Apartment Number" | translate
          }}<span class="optional">{{ "(optional)" | translate }}</span>
        </div>
        <div
          fxLayout="col"
          fxFlex="33"
          class="add-patient-col"
          fxLayoutAlign="start center"
          >
          {{ "Postcode" | translate }}
          <span class="optional">{{ "(optional)" | translate }}</span>
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
        <div fxLayout="col" fxFlex="33" class="add-patient-col">
          <input
            class="add-patient-input"
            [placeholder]="'Street Number' | translate"
            formControlName="streetNumber"
            [maxLength]="31"
            />
          </div>
          <div fxLayout="col" fxFlex="33" class="add-patient-col">
            <input
              class="add-patient-input"
              [placeholder]="'Apartment Number' | translate"
              formControlName="apartmentNumber"
              [maxLength]="31"
              />
            </div>
            <div fxLayout="col" fxFlex="33" class="add-patient-col">
              <input
                class="add-patient-input"
                [placeholder]="'Postcode' | translate"
                formControlName="postcode"
                [maxLength]="31"
                />
              </div>
            </div>
          </div>

          <div>
            <div fxLayout="row" fxLayoutAlign="center center" class="label-row">
              <div
                fxLayout="col"
                fxFlex="33"
                class="add-patient-col"
                fxLayoutAlign="start center"
                >
                {{ "Country" | translate }}
                <span class="optional">{{ "(optional)" | translate }}</span>
              </div>

              <div
                fxLayout="col"
                fxFlex="33"
                class="add-patient-col"
                fxLayoutAlign="start center"
                >
                {{ "Town" | translate }}
                <span class="optional">{{ "(optional)" | translate }}</span>
              </div>
              <div
                fxLayout="col"
                fxFlex="33"
                class="add-patient-col"
                fxLayoutAlign="start center"
                >
                {{ "District" | translate }}
                <span class="optional">{{ "(optional)" | translate }}</span>
              </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="center center" class="add-patient-row">
              <div fxLayout="col" fxFlex="33" class="add-patient-col">
                <nz-select
                  (keydown.enter)="$event.stopPropagation(); $event.preventDefault()"
                  class="add-patient-inputZorro"
                  nzShowSearch
                  [appTerminologySearch]="countriesList"
                  nzAllowClear
                  [nzPlaceHolder]="'Country' | translate"
                  formControlName="country"
                  (ngModelChange)="onCountryChange($event)"
                  >
                  @for (place of countriesList; track place) {
                    <nz-option [nzLabel]="place.name" [nzValue]="place.id"></nz-option>
                  }
                </nz-select>
              </div>
              <div fxLayout="col" fxFlex="33" class="add-patient-col">
                @if (!isCountryCyprus) {
                  <input
                    class="add-patient-input"
                    [placeholder]="'Town' | translate"
                    formControlName="town"
                    [maxLength]="51"
                    />
                  } @else {
                    <nz-select
                      (keydown.enter)="$event.stopPropagation(); $event.preventDefault()"
                      class="add-patient-inputZorro"
                      nzShowSearch
                      nzAllowClear
                      [nzPlaceHolder]="'Select a Town' | translate"
                      formControlName="town"
                      >
                      @for (city of cyprusCities; track city) {
                        <nz-option
                          [nzLabel]="city | translate"
                          [nzValue]="city"
                        ></nz-option>
                      }
                    </nz-select>
                  }
                  <!-- Dropdown if Cyprus -->
                </div>

                <div fxLayout="col" fxFlex="33" class="add-patient-col">
                  <input
                    class="add-patient-input"
                    [placeholder]="'District' | translate"
                    formControlName="district"
                    [maxLength]="51"
                    />
                  </div>
                </div>
              </div>
            </form>
